<div *ngIf="!loading; else loadingPage" class="activate-account-container" ccHideIntercom>
  <div *ngIf="!company.id" class="sm-mb-4 sm-text-center">
    <img src="./assets/images/dashpivot-logo.png" alt="Dashpivot logo" class="logo" />
  </div>
  <div class="activate-form-container">
    <div *ngIf="!activated" class="activation-content">
      <div>
        <div *ngIf="company?.logo" class="sm-mb-4 sm-text-center">
          <img src="{{ company.logo }}" alt="Dashpivot logo" class="company-logo" />
        </div>
        <div>
          <form
            #formBasicUserInfo="ngForm"
            name="formBasicUserInfo"
            class="form"
            [hidden]="currentForm !== 1"
          >
            <h5 i18n class="sm-mb-0 sm-text-center h5">Activate your Dashpivot account</h5>
            <div *ngIf="company?.name" class="sm-text-center" data-test="activation-context">
              <p i18n class="sm-m-0 sm-text-sm sm-text-default-text">
                Once your account is created, you will gain
                {{ isContributor ? 'internal' : 'external' }} access to the
                <span class="sm-font-bold">{{ company.name }}</span> workspace as a Dashpivot
                {{ isContributor ? 'Contributor' : 'Visitor' }}.
              </p>
            </div>
            <div>
              <input
                [value]="email"
                type="text"
                class="form-control sm-mb-4 sm-mt-6"
                data-test="activation-email"
                disabled
              />
            </div>
            <div class="form-group" [class.has-feedback]="firstName.valid">
              <input
                [(ngModel)]="model.firstName"
                [pattern]="doNotAcceptWithoutAlphanumeric"
                [class.error-state]="hasFormError(formBasicUserInfo, firstName)"
                type="text"
                class="form-control sm-capitalize"
                placeholder="First name"
                i18n-placeholder="First name"
                #firstName="ngModel"
                name="firstName"
                data-test="first-name"
                required
                ccFocus
              />
              <i class="input-feedback fa fa-check-circle text-success"></i>
              <div
                class="sm-text-default-red sm-mt-1 sm-text-xs"
                i18n
                *ngIf="hasFormError(formBasicUserInfo, firstName, 'pattern')"
                data-test="first-name-error"
              >
                First name is required
              </div>
            </div>
            <div class="form-group" [class.has-feedback]="lastName.valid">
              <input
                [(ngModel)]="model.lastName"
                [pattern]="doNotAcceptWithoutAlphanumeric"
                [class.error-state]="hasFormError(formBasicUserInfo, lastName)"
                type="text"
                class="form-control sm-capitalize"
                placeholder="Last name"
                i18n-placeholder="Lastname"
                #lastName="ngModel"
                name="lastName"
                data-test="last-name"
                required
              />
              <i class="input-feedback fa fa-check-circle text-success"></i>
              <div
                class="sm-text-default-red sm-mt-1 sm-text-xs"
                i18n
                *ngIf="hasFormError(formBasicUserInfo, lastName, 'pattern')"
                data-test="last-name-error"
              >
                Last name is required
              </div>
            </div>

            <div class="form-group" [class.has-feedback]="mobile.valid">
              <ng-select
                id="activate-country"
                class="mb-3 activate-country"
                name="country-list"
                [items]="countries"
                bindValue="value"
                bindLabel="name"
                placeholder="Select your country"
                i18n-placeholder="Select your country"
                [(ngModel)]="selectedCountry"
                filterPlaceholder="Type to search..."
                i18n-filterPlaceholder="Type to search..."
                (close)="handleCountrySelect()"
                [clearable]="false"
                [selectOnTab]="true"
              >
                <ng-template ng-label-tmp let-item="item">
                  <div class="country-option f16">
                    <div class="flag-icon flag {{ item.ccode | lowercase }}"></div>
                    <div>{{ item.name }}</div>
                  </div>
                </ng-template>
                <ng-template ng-label-tmp ng-option-tmp let-item="item">
                  <div class="country-option f16">
                    <div class="flag-icon flag {{ item.ccode | lowercase }}"></div>
                    <div>{{ item.name }}</div>
                  </div>
                </ng-template>
              </ng-select>
              <div class="input-group">
                <div class="input-group-addon">
                  <span data-test="area-code-input" class="input-group-text"
                    >({{ selectedCountryAreaCode }})</span
                  >
                </div>
                <input
                  [(ngModel)]="model.mobile"
                  type="tel"
                  class="form-control mobile-input"
                  [class.error-state]="!hasValidPhoneNumber"
                  id="mobile"
                  placeholder="Work mobile (e.g 401234567)"
                  i18n-placeholder="Work mobile (e.g 401234567)"
                  #mobileInput
                  #mobile="ngModel"
                  name="mobile"
                  required
                  pattern="[0-9]*"
                  digitOnly
                  (ngModelChange)="validatePhoneNumber()"
                />
                <i class="input-feedback fa fa-check-circle text-success"></i>
              </div>
              <div
                class="sm-text-default-red sm-mt-1 sm-text-xs"
                *ngIf="!hasValidPhoneNumber"
                data-test="mobile-danger"
              >
                <div *ngIf="mobile.errors?.required" i18n>Mobile is required</div>
                <div *ngIf="!mobile.errors?.required && !hasValidPhoneNumber" i18n>
                  Invalid mobile number - incorrect length.
                </div>
              </div>
            </div>

            <div class="form-group">
              <button
                type="submit"
                class="py-3 btn btn-primary flow btn-block"
                i18n
                ccSegmentCTA
                ctaContext="Invited Next 1"
                data-test="form-one-next-button"
                (click)="next(formBasicUserInfo)"
                [disabled]="!formBasicUserInfo?.valid || !hasValidPhoneNumber"
              >
                Next
              </button>
            </div>
          </form>
          <form
            #formSignature="ngForm"
            data-test="form-signature"
            name="formSignature"
            class="form"
            [hidden]="currentForm !== 2"
          >
            <h5 i18n class="sm-mb-0 sm-text-center h5">Create your signature</h5>
            <div class="sm-mb-6 sm-text-center">
              <p i18n class="sm-m-0 sm-text-sm sm-text-default-text">
                Draw your signature in the field below (don't worry, you can change it later!). You'll use
                your signature to sign-off and approve forms in Dashpivot.
              </p>
            </div>
            <div class="" [class.has-danger]="signature.invalid && formSignature.submitted">
              <input
                type="hidden"
                [(ngModel)]="model.signature"
                required
                name="signature"
                data-test="signature"
                #signature="ngModel"
              />
              <span
                class="sm-text-default-red sm-mt-1 sm-text-xs"
                i18n
                *ngIf="signature.invalid && formSignature.submitted"
                >Signature is required</span
              >
              <cc-signature-pad
                [options]="signaturePadOptions"
                (end)="drawComplete($event)"
              ></cc-signature-pad>
            </div>
            <div class="my-2 text-center form-group">
              <button
                class="btn btn-secondary btn-sm"
                type="button"
                title="Clear"
                i18n-title="Clear"
                (click)="clearSignature()"
              >
                <i class="fa fa-undo"></i>
              </button>
            </div>
            <div class="mb-1 form-group">
              <button
                type="submit"
                class="py-3 btn btn-primary btn-block"
                i18n
                ccSegmentCTA
                ctaContext="Invited Next 2"
                data-test="form-two-next-button"
                (click)="next(formSignature)"
                [disabled]="!model?.signature || isActivatingSSOSignup"
              >
                <span>{{ isSSOSignUp ? 'Activate' : 'Next' }}</span>
                <i *ngIf="isActivatingSSOSignup" class="cc-icon cc-icon-spinner-fw"></i>
              </button>
            </div>
          </form>
          <form
            #formPassword="ngForm"
            name="formPassword"
            data-test="form-password"
            class="form"
            [hidden]="currentForm !== 3"
          >
            <div
              class="form-group"
              [class.has-danger]="password.invalid && password.dirty"
              [class.has-feedback]="password.valid"
            >
              <input
                [(ngModel)]="model.password"
                type="password"
                class="form-control"
                placeholder="Password"
                (ngModelChange)="checkPassword($event)"
                i18n-placeholder="Password"
                #password="ngModel"
                name="password"
                data-test="password"
                required
                [class.error-state]="hasFormError(formPassword, password)"
                [pattern]="combinedPasswordValidationRegex"
              />
              <i class="input-feedback fa fa-check-circle text-success"></i>
              <div *ngIf="hasFormError(formPassword, password)">
                <cc-password-validation-list
                  [passwordValidation]="passwordValidation"
                ></cc-password-validation-list>
              </div>
            </div>
            <div
              class="form-group"
              [class.has-danger]="(confirmPassword.invalid || unmatched) && confirmPassword.dirty"
              [class.has-feedback]="confirmPassword.valid && !unmatched"
            >
              <input
                [(ngModel)]="model.confirmPassword"
                type="password"
                class="form-control"
                placeholder="Confirm password"
                (ngModelChange)="checkConfirmPassword($event)"
                i18n-placeholder="Confirm password"
                #confirmPassword="ngModel"
                name="confirmPassword"
                data-test="confirm-password"
                required
                [class.error-state]="hasFormError(formPassword, confirmPassword)"
              />
              <i class="input-feedback fa fa-check-circle text-success"></i>
              <ng-container *ngIf="confirmPassword.dirty">
                <p
                  class="sm-text-default-green sm-flex sm-gap-1 sm-text-xs sm-pt-1"
                  [class.sm-text-default-red]="!confirmPassword.valid"
                  i18n
                >
                  <i
                    class="cc-icon cc-icon-check sm-text-xl"
                    [class.cc-icon-close]="!confirmPassword.valid"
                  ></i>
                  Confirm password is required
                </p>
                <p
                  class="sm-text-default-green sm-flex sm-gap-1 sm-text-xs sm-mt-0"
                  [class.sm-text-default-red]="unmatched"
                  i18n
                >
                  <i class="cc-icon cc-icon-check sm-text-xl" [class.cc-icon-close]="unmatched"></i>
                  Confirm password matches the password
                </p>
              </ng-container>
            </div>
            <div class="form-group">
              <button
                [disabled]="!formPassword?.valid || unmatched || working"
                type="submit"
                class="py-3 btn btn-primary btn-block"
                ccSegmentCTA="Activate Button"
                (click)="activate(formPassword)"
                data-test="form-three-activate-button"
              >
                <span i18n>Activate</span> <i *ngIf="working" class="cc-icon cc-icon-spinner-fw"></i>
              </button>
            </div>
          </form>
        </div>
      </div>
      <div class="text-center nav-pill-container">
        <a
          class="nav-pill sm-cursor-pointer"
          [class.nav-pill-inactive]="currentForm !== 1"
          (click)="goToForm(1)"
        >
          <i class="fa fa-circle"></i
        ></a>
        <a
          class="nav-pill sm-cursor-pointer"
          [class.nav-pill-inactive]="currentForm !== 2"
          (click)="goToForm(2)"
        >
          <i class="fa fa-circle"></i
        ></a>
        <a
          *ngIf="!isSSOSignUp"
          class="nav-pill sm-cursor-pointer"
          [class.nav-pill-inactive]="currentForm !== 3"
          (click)="goToForm(3)"
        >
          <i class="fa fa-circle"></i
        ></a>
      </div>
    </div>
    <div *ngIf="activated" class="activation-success d-flex flex-column align-items-center">
      <div class="thumb-up"><i class="fa fa-thumbs-o-up text-success fa-5x font-weight-bold"></i></div>
      <h5 i18n class="m-3 h5 font-weight-bold">Congratulations!</h5>
      <div i18n class="mb-3">Your account is now active.</div>
      <div *ngIf="!done" class="text-center">
        <div i18n class="mb-3">Please wait...</div>
        <i class="fa fa-spin fa-circle-o-notch fa-lg"></i>
      </div>
      <div *ngIf="done && isMobile" class="mt-3 text-center">
        <a
          href="https://api.dashpivot.com/mobile/download-mobile-app"
          class="py-3 btn btn-primary"
          i18n
          _target="top"
          rel="noopener"
          ccSegmentCTA="Download App Link"
          ctaContext="Invited User"
        >
          Press here to download the app</a
        >
      </div>
    </div>
  </div>

  <div *ngIf="company?.id" class="sm-my-8 sm-text-center sm-w-100">
    <img src="./assets/images/dashpivot-logo-dark.png" alt="Dashpivot logo" class="footer-logo" />
    <p i18n class="sm-text-secondary-text sm-m-0 sm-pt-2">
      Powered By <span class="sm-font-bold">Sitemate</span>
    </p>
  </div>
</div>

<ng-template #loadingPage>
  <div class="app-loading-spinner">
    <img src="./assets/images/dashpivot-load.gif" alt="dashpivot loading animation" width="50px" />
    <div i18n>Loading Dashpivot</div>
  </div>
</ng-template>
